import styled from 'styled-components/native';

export const Wrapper = styled.View`
  margin: ${(props) => props.theme.SPACINGS.md}px;
`;
